<template>
  <v-container fluid>
    <v-row>
        <v-col>
            <v-card>
                <v-toolbar color="primary" dark flat>
                    <v-toolbar-title>Accounts</v-toolbar-title>
                </v-toolbar>
                <v-treeview
                    v-if="tree"
                    :items="tree"
                >
                    <template #label=" {item} ">
                        {{  item.account_no }} - {{ item.name }}
                    </template>
                </v-treeview>
            </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'BexioAccount',
    data: () => ({
        tree: null
    }),
    computed: {
        ...mapGetters('bexio', ['loading'])
    },
    mounted() {
        this.doLoadAccounts()
    },
    methods: {
        ...mapActions('bexio', { loadAccounts: 'loadAccounts'}),
        doLoadAccounts () {
            this.loadAccounts()
                .then(({accounts}) => {
                    this.tree = accounts
                })
        }
    }
}
</script>

<style>

</style>